export const DEBOUNCE_TIME = 300;
export const POWERFUL_DEBOUNCE_TIME = 1000;
export const DEBOUNCE_SHORT_TIME = 100;
